import { Spinner } from "@/components/ui/v2/spinner";

export const RouteFallback = () => (
  <div className="flex items-center justify-center w-full h-full min-h-[40vh]">
    <Spinner size="lg" />
  </div>
);
